import React, { useRef, useCallback } from 'react';
import { createPortal } from 'react-dom';
import Fit from 'react-fit';
import Options from '../Options';
import { DropdownWrapper } from './Dropdown.styles';
import { useOnClickOutside } from '../../../hooks';
import { DropdownProps } from './types';

const Dropdown = ({
  children,
  isOpen,
  onOptionSelect,
  options,
  onClose,
  maxWidth,
  maxHeight,
  alignment = 'left',
  portalContainer,
}: DropdownProps) => {
  const dropdownRef = useRef(null);
  const portalElement = portalContainer?.current;

  useOnClickOutside([dropdownRef], () => {
    if (isOpen) onClose();
  });

  const calculatePosition = useCallback(() => {
    const { height, width, left, top } =
      dropdownRef.current.getBoundingClientRect();

    const { left: portalLeft, top: portalTop } =
      portalContainer.current.getBoundingClientRect();

    return {
      left: left - portalLeft,
      top: top + height - portalTop,
      width,
    };
  }, [portalContainer]);

  const renderOptions = () => (
    <Options
      options={options}
      onSelect={(_e, value) => onOptionSelect(value)}
      maxWidth={maxWidth}
      maxHeight={maxHeight}
      alignment={alignment}
    />
  );

  return (
    <DropdownWrapper ref={dropdownRef}>
      {children}
      {isOpen && (
        <>
          {portalElement ? (
            createPortal(
              <div style={{ position: 'absolute', ...calculatePosition() }}>
                {renderOptions()}
              </div>,
              portalElement
            )
          ) : (
            <Fit>{renderOptions()}</Fit>
          )}
        </>
      )}
    </DropdownWrapper>
  );
};

export default Dropdown;
